import React from "react";

import InvoicePageContent from "../../components/invoice/InvoicePageContent";

function InvoicePage() {
  return <InvoicePageContent />;
}

export default InvoicePage;
